






import { Component, Prop, Vue } from 'vue-property-decorator'
import EvaIcon from '@/components/svg-components/EvaIcon.vue'
import TranslationModule from '@/utils/TranslationModule'

@Component({
    components: { EvaIcon },
})
export default class AuthFooterItem extends Vue {
    @Prop({ type: String, required: true }) logo!: string
    @Prop({ type: String, default: '' }) alt!: string
    @Prop({ type: String, required: true }) url!: string

    TranslationModule: typeof TranslationModule = TranslationModule
}
